<template>
  <div class="sdg-container">
    <div class="header">
      WIRTSCHAFT, BAUEN, WOHNEN UND GESUNDHEIT
    </div>
    <div class="separator"></div>
    <div class="content programme-block">
      <div class="programme-item">
        <div class="programme-title">UNSERE VISION #WEIDEN2040</div>
        Jede wirtschaftliche Aktivität in der Stadt dient dem Gemeinwohl und
        schützt unsere ökologischen Ressourcen. Weiden ist bundesweit ein städtebauliches
        Vorbild und die Chancen der Digitalisierung wurden genutzt.
        <br>
        <div class="programme-title">Das erreichen wir durch:</div>
      </div>

      
      <div @click="block1=!block1" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block1 }"></i>
         Regionale Energiepolitik</div>
        <div v-if="block1">
        100% regionalen Strom aus erneuerbaren Quellen, produziert durch die
        Stadtwerke.

        <br>
          Renovierungen und energiesparende Baumaßnahmen an städtischen
          Wohnungen, finanziert durch SGW und Stadtsparkasse;
        </div>
      </div>

      <div @click="block2=!block2" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block2 }"></i>
          Weitsichtige Wirtschaftsförderung</div>
        <div v-if="block2">
      Für uns hat qualitatives Wachstum Vorrang vor quantitativem
      Wirtschaftswachstum mit hohem Ressourcenverbrauch. Deshalb fördern wir
      Geschäftsmodelle, die Klima, Umwelt und Natur schützen und wollen diese
      aktiv in Weiden ansiedeln.  Die Wirtschaft muss dem Menschen – nicht der
      Mensch der Wirtschaft dienen. Die Ansiedlung dieser Form von Unternehmen
      mit geringen Flächenverbrauch ermöglicht die Schaffung von Arbeitsplätzen
      ohne städtische Expansion und Flächenversiegelung im Umland.
      <br>
      <br>
      Besondere Förderung für Start-ups und Bestandsfirmen im
      "second-use/repair"-Bereich sowie mit Geschäftsideen die positive soziale
      und ökologische Effekte erzielen.
        </div>
      </div>

      <div @click="block3=!block3" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block3 }"></i>
          Digitalisierung</div>
        <div v-if="block3">
          Die Digitalisierung bietet erhebliche Chancen für Gesellschaft und
          Wirtschaft. Um die positiven Aspekte der Digitalisierung zu nutzen, ohne
          unsere Lebensgrundlagen zu gefährden, setzen wir uns für einen maßvollen
          und klimaneutralen Ausbau digitaler Infrastruktur ein.
          <br>
          <br>
          Um die potentiell negativen Auswirkungen der Digitalisierung auf die
          Region minimieren, z.B. den Verlust von Arbeitsplätzen, setzen wir uns
          für den Ausbau regionaler Wertschöpfung z.B. durch Erneuerbare Energien
          ein.
        </div>
      </div>



      <div @click="block4=!block4" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block4 }"></i>
          Bauen und Wohnen</div>
        <div v-if="block4">
          Die Umsetzung des Wohnparks am Hammerweg mit Sozialwohnungen und
          „Mehrgenerationenhaus“.
          <br>
          Eine  Anhebung der angemessene Mietzuschüsse.
          <br>
          den Bau einer bedarfsgerechten Unterkunft für Obdachlose.
          <br>
          Den Erhalt und Umbau des Flurerturms mit sinnvoller Nutzung z.B. als
          Hotel mit Gastronomie und Biergarten.
        </div>
      </div>


      <div @click="block5=!block5" class="programme-item">
        <div class="programme-title">
        <i class="fa fa-chevron-right expand-icon" :class="{ expanded : block5 }"></i>
          Klinikum und Gesundheit</div>
        <div v-if="block5">
        Faire Arbeitsbedingungen für Ärzte und Pflegekräfte am Klinikum sowie
        gesunde regionale und frische Lebensmittel für die Klinikküche. Eine
        Privatisierung des Klinikums lehnen wir ab.
          <br>
          <br>
          Wir fördern Entwicklungen, die auf ein selbstbestimmtes Leben zielen;
          z. B. die Nutzung der Digitalisierung zum Erhalt der Eigenständigkeit im
          Alter (AAL =   Ambient Assisted Living).   Ziel ist es, Weiden und OTH
          zum Zentrum dieser Entwicklungen zu machen.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sdg04',
  data() {
    return {
      block1: false,
      block2: false,
      block3: false,
      block4: false,
      block5: false,
      block6: false,
    }
  },


}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
</style>
